import { Box } from '@mui/material';
import React from 'react';
export const MissionListWrapper = ({ children }) => {
    return (React.createElement(Box, { sx: { px: { xs: 2, sm: 4 }, pt: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 4 }, display: 'flex', flexDirection: 'column' } }, children));
};
